import { CustomTabList, Heading } from "@/components";
import { Card, Tabs, TabsContent } from "@/components/ui";
import { tabs } from "./consts";
import { CollectionDetails, School_Reports } from "./TabsData";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const MasterData = () => {
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // backend sends role as array, e.g. ["CRM_HEAD"]
  const roles = loggedInUserData?.role || [];

  // Helper to check if user has a given role
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  // 👇 If user is FINANCE_TEAM, show only Collection Details tab
  const visibleTabs = hasRole("FINANCE_TEAM")
    ? tabs.filter((tab: any) => tab.value === "1") // assuming "1" = Collection Details
    : tabs;

  return (
    <div className="p-7">
      <Heading title="Report" />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <Tabs defaultValue="1" className="mt-6 flex">
          <CustomTabList tabs={visibleTabs} className="mx-5" />

          {/* Render only relevant TabsContent */}
          {hasRole("FINANCE_TEAM") ? (
            <TabsContent value="1" className="px-0">
              <CollectionDetails />
            </TabsContent>
          ) : (
            <>
              <TabsContent value="1" className="px-0">
                <CollectionDetails />
              </TabsContent>

              <TabsContent value="2" className="px-0">
                <School_Reports />
              </TabsContent>
            </>
          )}
        </Tabs>
      </Card>

      <Outlet />
    </div>
  );
};

export default MasterData;
